import i18n from '../../../i18n';

const validate = values => {
  const errors = {};
  if (!values.firstName) {
    errors.firstName = i18n.t('components.profile.profileForm.validate.firstName');
  } else if (values.firstName.length > 20) {
    errors.firstName = i18n.t('components.profile.profileForm.validate.firstNameError');
  }
  if (!values.lastName) {
    errors.lastName = i18n.t('components.profile.profileForm.validate.lastName');
  } else if (values.lastName.length > 20) {
    errors.lastName = i18n.t('components.profile.profileForm.validate.lastNameError');
  }
  if (!values.phone) {
    errors.phone = i18n.t('components.profile.profileForm.validate.phone');
  } else if (values.phone.replace(/\D/g, '').length < 11) {
    errors.phone = i18n.t('components.profile.profileForm.validate.phoneError');
  }
  if (!values.email) {
    errors.email = i18n.t('components.profile.profileForm.validate.email');
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,63}$/i.test(values.email)) {
    errors.email = i18n.t('components.profile.profileForm.validate.emailError');
  } else if (values.email.length > 50) {
    errors.email = i18n.t('components.profile.profileForm.validate.emailError1');
  }
  if (!values.position) {
    errors.position = i18n.t('components.profile.profileForm.validate.position');
  } else if (values.position.length > 30) {
    errors.position = i18n.t('components.profile.profileForm.validate.positionError');
  }
  if (values.description && values.description.length > 250) {
    errors.description = i18n.t('components.profile.profileForm.validate.positionError1');
  }
  return errors;
};

export default validate;



// WEBPACK FOOTER //
// ./src/components/Profile/ProfileForm/validate.js